/* ============================================================
   Fibrolab — autoplay para los carruseles de producto (móvil/tablet).
   Avanza el slider de <slider-component> que contiene .product-grid.slider--tablet.
   - Solo en <990px (donde el grid es slider). No hace nada en desktop.
   - Respeta prefers-reduced-motion.
   - Pausa al hover/focus/touch/click y reanuda tras un rato; pausa fuera de viewport.
   ============================================================ */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var INTERVAL = 4500; // ms entre avances
  var RESUME = 9000; // ms para reanudar tras interacción manual
  var mq = window.matchMedia('(max-width: 989px)');

  function setup(sc) {
    if (sc.__fbAuto) return;
    var slider = sc.querySelector('.product-grid.slider--tablet, .fb-cats__track');
    if (!slider) return;
    sc.__fbAuto = true;

    var timer = null;
    var resumeT = null;

    function step() {
      if (!mq.matches) return;
      var max = slider.scrollWidth - slider.clientWidth;
      if (max <= 4) return; // no hay overflow → nada que rotar
      var slide = slider.querySelector('.slider__slide');
      var gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
      var amount = slide ? slide.getBoundingClientRect().width + gap : slider.clientWidth;
      if (slider.scrollLeft >= max - 4) {
        slider.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        slider.scrollBy({ left: amount, behavior: 'smooth' });
      }
    }

    function play() {
      stop();
      if (mq.matches) timer = setInterval(step, INTERVAL);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function bump() {
      stop();
      clearTimeout(resumeT);
      resumeT = setTimeout(play, RESUME);
    }

    sc.addEventListener('mouseenter', stop);
    sc.addEventListener('mouseleave', play);
    sc.addEventListener('focusin', stop);
    sc.addEventListener('focusout', play);
    sc.addEventListener('touchstart', bump, { passive: true });
    sc.addEventListener('click', bump);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.isIntersecting ? play() : stop(); });
      }, { threshold: 0.25 });
      io.observe(sc);
    } else {
      play();
    }
  }

  function init() {
    document.querySelectorAll('slider-component').forEach(setup);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
